module.exports = __webpack_public_path__ + "media/honey-icons/icon-notifications-settings-24fa9be0.svg";